<template>
    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.97 33.97">
        <title>phone</title>
        <path d="M17,34A17,17,0,1,1,34,17,17,17,0,0,1,17,34ZM17,1A16,16,0,1,0,33,17,16,16,0,0,0,17,1Z" style="fill: #fff" />
        <path d="M8.58,14.07h3.6V25.66H8.58Zm1.8-5.76A2.09,2.09,0,1,1,8.3,10.4a2.09,2.09,0,0,1,2.09-2.09" style="fill: #fff" />
        <path d="M14.45,14.07H17.9v1.58h0a3.78,3.78,0,0,1,3.41-1.87c3.65,0,4.32,2.4,4.32,5.52v6.35h-3.6V20c0-1.34,0-3.07-1.87-3.07S18,18.42,18,19.93v5.73h-3.6Z" style="fill: #fff" />
    </svg>
</template>

<script>
export default {
    name: "LinkedinIcon",
};
</script>

<style scoped></style>
